import useCurrentLocation from "Hooks/useCurrentLocation";
import useViewTransitionNavigate from "Hooks/useViewTransitionNavigate";
import { BiSupport } from "react-icons/bi";
import { BsBuildingAdd, BsBuildingDash } from "react-icons/bs";
import { HiMiniNewspaper } from "react-icons/hi2";
import { MdHomeWork } from "react-icons/md";
import { PiHandDepositFill, PiHandWithdrawFill } from "react-icons/pi";

const links = [
  {
    to: "/control-panel",
    icon: <MdHomeWork className="text-white" />,
    label: "الرئيسية",
  },
  {
    to: "/control-panel/bank-notice",
    icon: <PiHandDepositFill className="text-white" />,
    label: "إيداع",
  },
  {
    to: "/control-panel/categories",
    icon: <PiHandWithdrawFill className="text-white" />,
    label: "سحب",
  },
  {
    to: "/control-panel/my-payments",
    icon: <BsBuildingAdd className="text-white" />,
    label: "سجل الإيداع",
  },
  {
    to: "/control-panel/my-orders",
    icon: <BsBuildingDash className="text-white" />,
    label: "سجل السحب",
  },
  {
    to: "/control-panel/financial-statement",
    icon: <HiMiniNewspaper className="text-white" />,
    label: "البيان المالي",
  },
  {
    to: "/control-panel/contact-us",
    icon: <BiSupport className="text-white" />,
    label: "الدعم الفني",
  },
];

export default function NavigateBar() {
  const currentLocation = useCurrentLocation();
  const navigate = useViewTransitionNavigate();

  return (
    <div className="bg-mainLight/80 h-12 hidden backdrop-blur-md lg:block">
      <ul className="max-w-6xl px-4 m-auto flex items-center justify-between text-white h-full overflow-hidden">
        {links.map((link, index) => (
          <li key={index}>
            <div
              onClick={() => navigate(link.to)}
              // to={link.to}
              className={`px-2 py-1.5 rounded-md cursor-pointer text-nowrap hover:bg-white/15 duration-700 flex gap-2 items-center group text-sm ${
                currentLocation == link.to && "bg-white/15"
              }`}
            >
              <span className="text-2xl duration-700 group-hover:scale-110">
                {link.icon}
              </span>
              {link.label}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
